// import React from "react";

// const taxiData = [
//   {
//     image: "/images/fleets/Dzire.jpg",
//     title: "Maruti Suzuki Dzire",
//   },
//   {
//     image: "/images/fleets/aura.jpg",
//     title: "Hyundai Aura",
//   },
//   {
//     image: "/images/fleets/Ertiga.jpg",
//     title: "Maruti Suzuki Ertiga",
//   },
//   {
//     image: "/images/fleets/crysta.jpg",
//     title: "Toyota Innova Crysta",
//   },
//   {
//     image: "/images/fleets/innova.jpg",
//     title: "Toyota Innova",
//   },
//   {
//     image: "/images/fleets/kia.jpg",
//     title: "Kia Carens",
//   },
//   {
//     image: "/images/fleets/urbania.jpg",
//     title: "Force Urbania",
//   },
//   {
//     image: "/images/fleets/tempo-traveller.jpg",
//     title: "Force Tempo Traveller",
//   },
//   {
//     image: "/images/fleets/bus.jpg",
//     title: "Luxury Coach Bus",
//   },
// ];

// const Booking = () => {

//   const handleWhatsApp = (carName) => {
//     const phoneNumber = "919594849797";
//     const message = `Hello, I want to book ${carName}. Please share details.`;
//     const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
//     window.open(url, "_blank");
//   };

//   return (
//     <>
//       <div className="breadcrumb-bar">
//         <div className="container">
//           <div className="row align-items-center text-center">
//             <div className="col-md-12 col-12">
//               <h2 className="breadcrumb-title text-white">
//                 Online Booking
//               </h2>
//             </div>
//           </div>
//         </div>
//       </div>

//       <section className="taxi-style-one taxi-page">
//         <div className="container">
//           <div className="row">

//             {taxiData.map((taxi, index) => (
//               <div className="col-lg-4 col-md-6 col-sm-12" key={index}>
//                 <div className="single-taxi-one">
//                   <div className="inner-content">

//                     <img
//                       src={taxi.image}
//                       alt={taxi.title}
//                       className="img-fluid"
//                     />

//                     <h3>{taxi.title}</h3>

//                     <button
//                       className="book-now-btn"
//                       onClick={() => handleWhatsApp(taxi.title)}
//                     >
//                       Book Now
//                     </button>

//                   </div>
//                 </div>
//               </div>
//             ))}

//           </div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default Booking;







import React from "react";

const taxiData = [
  {
    image: "/images/fleets/Dzire.jpg",
    title: "Maruti Suzuki Dzire",
    seater: "4+1 Seater",
    luggage: "2 Bags",
    ac: "AC",
    price: "₹10/km",
  },
  {
    image: "/images/fleets/aura.jpg",
    title: "Hyundai Aura",
    seater: "4+1 Seater",
    luggage: "2 Bags",
    ac: "AC",
    price: "₹10/km",
  },
  {
    image: "/images/fleets/Ertiga.jpg",
    title: "Maruti Suzuki Ertiga",
    seater: "6+1 Seater",
    luggage: "4 Bags",
    ac: "AC",
    price: "₹13/km",
  },
  {
    image: "/images/fleets/crysta.jpg",
    title: "Toyota Innova Crysta",
    seater: "7+1 Seater",
    luggage: "5 Bags",
    ac: "AC",
    price: "₹18/km",
  },
  {
    image: "/images/fleets/innova.jpg",
    title: "Toyota Innova",
    seater: "6+1 Seater",
    luggage: "4 Bags",
    ac: "AC",
    price: "₹16/km",
  },
  {
    image: "/images/fleets/kia.jpg",
    title: "Kia Carens",
    seater: "6+1 / 7+1 Seater",
    luggage: "4 Bags",
    ac: "AC",
    price: "₹15/km",
  },
  {
    image: "/images/fleets/urbania.jpg",
    title: "Force Urbania",
    seater: "12 / 17 Seater",
    luggage: "12 Bags",
    ac: "AC",
    price: "₹25/km",
  },
  {
    image: "/images/fleets/tempo-traveller.jpg",
    title: "Tempo Traveller",
    seater: "12 / 17 Seater",
    luggage: "10 Bags",
    ac: "AC",
    price: "₹22/km",
  },
  {
    image: "/images/fleets/bus.jpg",
    title: "Luxury Coach Bus",
    seater: "30–50 Seater",
    luggage: "20+ Bags",
    ac: "AC",
    price: "On Call",
  },
];

const Booking = () => {
  const handleWhatsApp = (car) => {
    const phoneNumber = "919594849797";

    const message = `🚖 Hello,

I want to book *${car.title}*.

📌 Vehicle Details:
👥 Seating: ${car.seater}
🧳 Luggage: ${car.luggage}
❄️ AC: ${car.ac}
💰 Price: ${car.price}

Please share availability, pickup details & booking confirmation.

Thank you.`;

    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
  };

  return (
    <>
      {/* HEADER */}
      <div className="breadcrumb-bar">
        <div className="container text-center">
          <h2 className="breadcrumb-title text-white">
            Online Booking
          </h2>
        </div>
      </div>

      {/* SECTION */}
      <section className="taxi-page">
        <div className="container">

          <div className="row">

            {taxiData.map((taxi, index) => (
              <div className="col-lg-4 col-md-6 col-sm-12" key={index}>

                <div className="taxi-card">

                  {/* IMAGE */}
                  <div className="taxi-img">
                    <img src={taxi.image} alt={taxi.title} />
                   
                  </div>

                  {/* CONTENT */}
                  <div className="taxi-content">

                    <h3>{taxi.title}</h3>

                    {/* ALL INFO INCLUDED */}
                    <div className="taxi-badges">
                      <span>👥 {taxi.seater}</span>
                      <span>🧳 {taxi.luggage}</span>
                      <span>❄️ {taxi.ac}</span>
                    </div>

                    <button
                      className="book-btn"
                      onClick={() => handleWhatsApp(taxi)}
                    >
                      Book on WhatsApp
                    </button>

                  </div>

                </div>

              </div>
            ))}

          </div>
        </div>
      </section>
    </>
  );
};

export default Booking;